import { render, staticRenderFns } from "./Notifier.vue?vue&type=template&id=65a118a1&scoped=true"
import script from "./Notifier.vue?vue&type=script&lang=ts"
export * from "./Notifier.vue?vue&type=script&lang=ts"
import style0 from "./Notifier.vue?vue&type=style&index=0&id=65a118a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a118a1",
  null
  
)

export default component.exports